import { DateView, PickersLayoutProps } from '@mui/x-date-pickers';
import { DatePickerLayout as MUIDatePickerLayout } from './DatePickerLayout.css';

export default function DatePickerLayout(
  props: PickersLayoutProps<Date | null, Date, DateView>,
) {
  return <MUIDatePickerLayout {...props} />;
}
